<!--suppress ALL -->

<template>
  <tr>
    <td class="text-right">
      {{ question.id }}
    </td>
    <td class="text-right">
      {{ question.question || "ללא תוכן" }}
    </td>
    <td class="text-right">
      {{
        (question.answer && question.answer.content) ||
          question.true_false_answer
      }}
    </td>

    <td class="text-right">
      {{ questionType }}
    </td>
    <td>
      <div v-if="question.tags">
        <v-chip
          v-for="tag in question.tags"
          :key="tag.id"
          label
          small
          class="ml-1 mb-1"
        >
          <span class="pr-2">{{ tag.name }}</span>
        </v-chip>
      </div>
    </td>
    <td class="text-right">
      <span v-if="question.company">{{ question.company.name }}</span>
    </td>
    <td>
      <edit-btn class="mx-2 my-1" @click="onEdit" />
      <remove-btn class="mx-2 my-1" @remove="doRemove" />
    </td>
  </tr>
</template>

<script>
import { types } from "../../store/Question.module";
import RemoveBtn from "dev/scaffoldings/RemoveBtn";
import EditBtn from "dev/scaffoldings/EditBtn";
import RowMixin from "dev/mixins/RowMixin";
import QuestionType from "root/packages/closeapp/QuestionsManager/assets/types/QuestionType";

export default {
  name: "QuestionRow",
  components: { EditBtn, RemoveBtn },
  props: {
    question: { required: true }
  },
  mixins: [new RowMixin(types, "question")],
  data() {
    return {};
  },
  computed: {
    questionType() {
      return QuestionType.toString(this.question.question_type);
    }
  },
  methods: {
    doRemove() {
      this.$store.dispatch(types.REMOVE, this.question).then(() => {});
    },
    onEdit() {
      this.$emit("edit", this.question);
    }
  }
};
</script>

<style></style>
